// extracted by mini-css-extract-plugin
export default {"DataField":"_DataField--WuRjh","Description":"_Description--y4QTQ","Label":"_Label--YfEwM"};